import type { Input } from '@builder.io/sdk';

export const resourceCarouselFields = [
  {
    name: 'title',
    type: 'string',
  },
] as const satisfies DeepReadonly<Input[]>;

const resourceCarouselConfig = {
  name: 'Resource Carousel',
  inputs: resourceCarouselFields,
};

export type ResourceCarouselProps = GenerateBuilder<typeof resourceCarouselFields>;

export default resourceCarouselConfig;
